import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback exchanges session_id first
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => api.post("/auth/refresh").then((r) => { localStorage.setItem("abs_token", r.data.token); setUser(r.data); }).catch(() => setUser(false)));
  }, []);

  const signIn = async (path, body) => {
    const { data } = await api.post(path, body);
    localStorage.setItem("abs_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("abs_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login: (b) => signIn("/auth/login", b), register: (b) => signIn("/auth/register", b),
      googleSession: (session_id) => signIn("/auth/google/session", { session_id }), setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
